import apiClient from "./apiClient";

export const fetchOemScans = async (params = {}) => {
  try {
    const { search = "", page = 1, limit = 10, almataId, oemId } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(almataId && { almataId }),
      ...(oemId && { oemId })
    });
    const response = await apiClient.get(`/partners/almata-partners/oem-partners/scan/list?${queryParams}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};